export function GammaIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M8.00065 9.33398C10.2098 9.33398 12.0007 7.54312 12.0007 5.33398C12.0007 3.12485 10.2098 1.33398 8.00065 1.33398C5.79151 1.33398 4.00065 3.12485 4.00065 5.33398C4.00065 7.54312 5.79151 9.33398 8.00065 9.33398Z' />
      <path
        d='M8.00065 13.6488C8.70832 14.2822 9.64284 14.6673 10.6673 14.6673C12.8765 14.6673 14.6673 12.8765 14.6673 10.6673C14.6673 8.8227 13.4187 7.26971 11.7205 6.80743M4.28077 6.80743C2.58261 7.2697 1.33398 8.82269 1.33398 10.6673C1.33398 12.8765 3.12485 14.6673 5.33398 14.6673C7.54312 14.6673 9.33398 12.8765 9.33398 10.6673C9.33398 10.147 9.23463 9.64986 9.05387 9.19388M12.0007 5.33398C12.0007 7.54312 10.2098 9.33398 8.00065 9.33398C5.79151 9.33398 4.00065 7.54312 4.00065 5.33398C4.00065 3.12485 5.79151 1.33398 8.00065 1.33398C10.2098 1.33398 12.0007 3.12485 12.0007 5.33398Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
